import { useT } from "@/i18n/LangProvider";

export default function Fit() {
  const { t } = useT();
  const yes = t("fit.yes") || [];
  const no = t("fit.no") || [];

  return (
    <section
      id="fit"
      data-testid="fit-section"
      className="section"
      style={{ background: "var(--navy-mid)" }}
    >
      <div className="section-inner">
        <p className="eyebrow fade-up">{t("fit.eyebrow")}</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 mb-16 fade-up">
          {t("fit.title1")}{" "}
          <em className="text-[color:var(--gold-light)]">
            {t("fit.title_em")}
          </em>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div
            className="p-10"
            style={{
              background: "rgba(184,150,46,0.06)",
              borderLeft: "2px solid var(--gold)",
            }}
            data-testid="fit-yes"
          >
            <p className="font-mono-brand text-[color:var(--gold-light)] text-xs mb-6">
              {t("fit.yes_title")}
            </p>
            <ul className="space-y-5">
              {yes.map((y, i) => (
                <li key={i} className="flex gap-4 items-start fade-up">
                  <span className="text-[color:var(--gold-light)] font-mono-brand text-lg">
                    ✓
                  </span>
                  <span className="font-sans-brand text-[color:var(--white)] leading-relaxed">
                    {y}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div
            className="p-10"
            style={{
              background: "var(--navy-deep)",
              borderLeft: "2px solid rgba(245,245,240,0.12)",
            }}
            data-testid="fit-no"
          >
            <p className="font-mono-brand text-[color:var(--muted-white)] text-xs mb-6">
              {t("fit.no_title")}
            </p>
            <ul className="space-y-5">
              {no.map((n, i) => (
                <li key={i} className="flex gap-4 items-start fade-up">
                  <span className="font-mono-brand text-lg text-[color:var(--muted-white)]">
                    ✗
                  </span>
                  <span className="font-sans-brand text-[color:var(--muted-white)] leading-relaxed">
                    {n}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
